import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Router } from '@angular/router';
import { environment as env } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class LoginService {

  constructor(
    private http: HttpClient,
    private constantes: ConstantesService,
    private router: Router,
    private cookies: CookieService
  ) {}

  getToken(user: string, password: string): Observable<any> {

    this.cookies.deleteAll();

    const formData: FormData = new FormData();
    formData.append('grant_type', 'password');
    formData.append('client_id', env.clientId);
    formData.append('client_secret', env.clientSecret);
    formData.append('username', user);
    formData.append('password', password);

    return this.http.post(environment.urlBase + 'token', formData);
  }

  getUserLogueado(): Observable<any> {
    return this.http.get(environment.urlBase + 'getUserToken', this.constantes.httpOptions);
  }

  logout() {
    this.cookies.deleteAll();
    sessionStorage.clear();
    localStorage.removeItem('activoSeleccionadoId');
    this.http.get(environment.urlBase + 'logout', this.constantes.httpOptions).subscribe(
      data => {
        // En data.items viene un Hasta pronto!
        // console.log(data);

      },
      err => {
        console.log(err);

      }
    );
    // Esto no lo meto en el subscribe porque me voy a ir de todas formas, el logout del back es solo un control adicional de seguridad
    this.router.navigateByUrl('/login');
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/login/login.service.ts